import React, { Component } from 'react';
import { Button, Tooltip, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import map from 'lodash/map';
import join from 'lodash/join';
import PrescreenEditAnswerDrawer from 'containers/Manage-Questionnaire/prescreen/PrescreenEditAnswerDrawer';
import { DialogWrapper } from 'components/DialogWrapper';
import { archivePrescreenAnswer } from 'api/prescreen';
import { AppToaster } from 'components/AppToaster';
import {
  TableData,
  TableDataIcons,
  NoWrapTD,
} from 'components/styled-components';
import { TableRow } from 'containers/Manage-Questionnaire/styled-components';
import { statusByVersionStatus } from 'utils/functions';
import { pluckFromArray } from 'utils/functions';
import { shouldBold } from 'utils/functions';

class Row extends Component {
  constructor(props) {
    super(props);
    const isFilterAMatch =
      props.filter &&
      pluckFromArray(
        props.answer.displayCategory,
        'categoryName',
        props.filter.label
      );
    this.state = {
      isOpen: false,
      removeAnswer: false,
      isFilterAMatch: isFilterAMatch,
    };
  }
  openDrawer = () => this.setState({ isOpen: true });
  closeDrawer = () => this.setState({ isOpen: false });
  handleDismissRemoveAnswer = () => this.setState({ removeAnswer: false });
  openRemoveAnswerDialog = () => this.setState({ removeAnswer: true });

  handleArchiveAnswer = (id, status) => {
    archivePrescreenAnswer(id, status)
      .then(res => {
        AppToaster.show({
          message: res.data.message,
          intent: Intent.SUCCESS,
        });
        this.props.fetchPrescreenQuestions();
        this.handleDismissRemoveAnswer();
      })
      .catch(err => {
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
        this.handleDismissRemoveAnswer();
      });
  };

  render() {
    const { answer, isLastAnswer, searchQuery } = this.props;
    const status = statusByVersionStatus(answer.versionStatus);

    return (
      <React.Fragment>
        <TableRow
          key={answer.answerID}
          className={this.state.isFilterAMatch && 'light-blue'}
        >
          <TableData>{answer.answerID}</TableData>
          <NoWrapTD>{shouldBold(answer.answer, searchQuery)}</NoWrapTD>
          <TableData
            dangerouslySetInnerHTML={{
              __html: join(
                map(answer.displayCategory, c => {
                  return this.props.filter &&
                    c.categoryName === this.props.filter.label
                    ? `<strong>${c.categoryName}</strong>`
                    : c.categoryName;
                }),
                ', '
              ),
            }}
          />
          <TableDataIcons>
            <Tooltip content="Edit">
              <Button
                icon={IconNames.EDIT}
                minimal={true}
                onClick={this.openDrawer}
              />
            </Tooltip>
          </TableDataIcons>

          <TableDataIcons>
            {!isLastAnswer && (
              <Tooltip content={'Remove'}>
                <Button
                  icon={IconNames.TRASH}
                  onClick={this.openRemoveAnswerDialog}
                  minimal
                />
              </Tooltip>
            )}
          </TableDataIcons>
        </TableRow>
        <PrescreenEditAnswerDrawer
          isOpen={this.state.isOpen}
          closeDrawer={this.closeDrawer}
          answer={answer}
          {...this.props}
        />

        <DialogWrapper
          isOpen={this.state.removeAnswer}
          onClose={this.handleDismissRemoveAnswer}
          title={'Remove Answer'}
          body={status.getBodyAnswer}
          confirm={'REMOVE'}
          action={
            this.props.newQuestion
              ? () => {
                  this.props.archiveLocalAnswer(this.props.index);
                  this.closeDrawer();
                }
              : () =>
                  this.handleArchiveAnswer(
                    answer.answerID,
                    answer.versionStatus
                  )
          }
        />
      </React.Fragment>
    );
  }
}

export default Row;
